<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card>
      <v-flex text-xs-center pt-5>
        <v-flex>
          <img style="vertical-align:text-top;" width="390" :src="logo"/>
        </v-flex>
        <v-flex pt-3>
          <v-progress-circular
            :size="70"
            :width="7"
            color="white"
            indeterminate
          ></v-progress-circular>
        </v-flex>
        <v-flex class="pt-2">
          Cerrando Sesión...
        </v-flex>
      </v-flex>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'logout-modal',
  data() {
    return {
      dialog: true,
      logo: 'https://dj28xnb5b9x1h.cloudfront.net/images/assets-omnitrack/omnitrack-logo-dark.svg'
    }
  }
}
</script>

<style lang="stylus" scoped>

</style>


// WEBPACK FOOTER //
// src/components/LogoutModal.vue